import { CursorsState } from 'js/types';

export const findCursorById = (cursors: CursorsState, cursorId: number) => {
  return (
    Object.values(cursors)
      .flat()
      .find(cursor => cursor.id === cursorId)
  );
};
